import { useQuery } from "hooks/useQuery";
import { previewUpgrade } from "../service";

// Stripe proration preview for upgrading to `planId`. Runs only while `enabled`
// (i.e. the upgrade modal is open). Proration is time-sensitive, so it isn't cached.
export const usePreviewUpgrade = (planId, enabled) => {
  const active = Boolean(enabled && planId);

  const { data, isLoading, isError } = useQuery({
    queryKey: ["preview-upgrade", planId],
    queryFn: () => previewUpgrade(planId),
    enabled: active,
    staleTime: 0,
    cacheTime: 0,
  });

  return {
    preview: data ?? null,
    loading: active && isLoading,
    isError,
  };
};
